import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Link, useLocation } from 'react-router-dom';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { AbilityContext, defaultAbility } from './config/ability';
import ProtectedRoute from './components/ProtectedRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import TrainingList from './pages/TrainingList';
import CreateTraining from './pages/CreateTraining';
import TrainingDetail from './pages/TrainingDetail';
import Reports from './pages/Reports';
import MyAccount from './pages/MyAccount';
import UserManagement from './pages/UserManagement';
import ParticipantManagement from './pages/ParticipantManagement';
import CreateUser from './pages/CreateUser';
import EditUser from './pages/EditUser';
import CreateParticipant from './pages/CreateParticipant';
import EditParticipant from './pages/EditParticipant';
import TrainingParticipants from './pages/TrainingParticipants';
import Attendance from './pages/Attendance';
import ResetPassword from './pages/ResetPassword';
import EmailConfig from './pages/EmailConfig';
import Settings from './pages/Settings';
import AuditLogs from './pages/AuditLogs';
import RoomManagement from './pages/RoomManagement';
import TrainingCalendar from './pages/TrainingCalendar';
import ProfileManagement from './pages/ProfileManagement';
import TabletMode from './pages/TabletMode';
import SidebarMenu from './components/SidebarMenu';
import Footer from './components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import { FiCheckSquare } from 'react-icons/fi';

function App() {
    return (
        <AbilityContext.Provider value={defaultAbility}>
            <Router>
                <div className="app-container">
                    <SidebarMenu />
                    <div className="main-content">
                        <Routes>
                            <Route path="/login" element={<Login />} />
                            <Route path="/register" element={<ProtectedRoute action="create" subject="User"><Register /></ProtectedRoute>} />
                            <Route path="/dashboard" element={<ProtectedRoute action="read" subject="Dashboard"><Dashboard /></ProtectedRoute>} />
                            <Route path="/training-list" element={<ProtectedRoute action="read" subject="Training"><TrainingList /></ProtectedRoute>} />
                            <Route path="/calendar" element={<ProtectedRoute action="read" subject="Calendar"><TrainingCalendar /></ProtectedRoute>} />
                            <Route path="/create-training" element={<ProtectedRoute action="create" subject="Training"><CreateTraining /></ProtectedRoute>} />
                            <Route path="/training/:id" element={<ProtectedRoute action="read" subject="Training"><TrainingDetail /></ProtectedRoute>} />
                            <Route path="/training/:id/edit" element={<ProtectedRoute action="update" subject="Training"><CreateTraining /></ProtectedRoute>} />
                            <Route path="/training/:id/participants" element={<ProtectedRoute action="read" subject="Training"><TrainingParticipants /></ProtectedRoute>} />
                            <Route path="/report/:id" element={<ProtectedRoute action="read" subject="Report"><Reports /></ProtectedRoute>} />
                            <Route path="/my-account" element={<ProtectedRoute action="manage" subject="MyAccount"><MyAccount /></ProtectedRoute>} />
                            <Route path="/user-management" element={<ProtectedRoute action="read" subject="User"><UserManagement /></ProtectedRoute>} />
                            <Route path="/users/new" element={<ProtectedRoute action="create" subject="User"><CreateUser /></ProtectedRoute>} />
                            <Route path="/users/:id/edit" element={<ProtectedRoute action="update" subject="User"><EditUser /></ProtectedRoute>} />
                            <Route path="/participant-management" element={<ProtectedRoute action="read" subject="Participant"><ParticipantManagement /></ProtectedRoute>} />
                            <Route path="/participants/new" element={<ProtectedRoute action="create" subject="Participant"><CreateParticipant /></ProtectedRoute>} />
                            <Route path="/participants/:id/edit" element={<ProtectedRoute action="update" subject="Participant"><EditParticipant /></ProtectedRoute>} />
                            <Route path="/email-config" element={<ProtectedRoute action="manage" subject="EmailConfig"><EmailConfig /></ProtectedRoute>} />
                            <Route path="/settings" element={<ProtectedRoute action="manage" subject="SystemConfig"><Settings /></ProtectedRoute>} />
                            <Route path="/audit-logs" element={<ProtectedRoute action="read" subject="AuditLog"><AuditLogs /></ProtectedRoute>} />
                            <Route path="/rooms" element={<ProtectedRoute action="manage" subject="Room"><RoomManagement /></ProtectedRoute>} />
                            <Route path="/profiles" element={<ProtectedRoute action="manage" subject="Profile"><ProfileManagement /></ProtectedRoute>} />
                            <Route path="/tablet-mode" element={<ProtectedRoute action="manage" subject="Tablet"><TabletMode /></ProtectedRoute>} />
                            <Route path="/attendance/:token" element={<Attendance />} />
                            <Route path="/reset-password" element={<ResetPassword />} />
                            <Route path="/" element={<Navigate to="/dashboard" />} />
                        </Routes>
                    </div>
                    <Footer />
                </div>
            </Router>
        </AbilityContext.Provider>
    );
}

export default App;
